import React from 'react'
import './spinner.css'

export default function Spinner() {
	return(
		<div className="cs-loader spinner hidden">
	  		<div className="cs-loader-inner">
	    		<label> ●</label>
	    		<label>	●</label>
	    		<label>	●</label>
	    		<label>	●</label>
	    		<label>	●</label>
	    		<label>	●</label>
	  		</div>
		</div>
	)
}


// WEBPACK FOOTER //
// ./src/components/spinner.js